"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIN_INVOICE_RESPONSE_EXAMPLE = void 0;
exports.FIN_INVOICE_RESPONSE_EXAMPLE = {
    id: '11111111-1111-4111-8111-111111111111',
    invoiceNumber: 'OPD-INV-2026-000001',
    documentType: 'OPD',
    branchId: '22222222-2222-4222-8222-222222222222',
    hospitalId: null,
    patientId: '33333333-3333-4333-8333-333333333333',
    payerId: null,
    invoiceDate: '2026-07-20',
    dueDate: '2026-08-19',
    grossAmount: 100000,
    discountAmount: 0,
    taxAmount: 18000,
    netAmount: 118000,
    amountPaid: 40000,
    amountOutstanding: 78000,
    overpaidAmount: 0,
    status: 'PARTIALLY_PAID',
    cancelReason: null,
    writeOffReason: null,
    sourceEventLogId: '44444444-4444-4444-8444-444444444444',
    createdAt: '2026-07-20T09:55:00.000Z',
};
//# sourceMappingURL=financial-receivable.response.js.map